import styled from 'styled-components';

interface Props {
    hideOnMobile?: boolean;
}
export const ContentSection = styled.div<Props>`
    margin-bottom: 24px;
`;
